import React from "react";
import AddTableColumnIcon from "../../icons/AddTableColumnIcon";
import { IconButton, Typography } from "@material-ui/core";

const EmptyStateCreateDataTable = ({
  onAddColumn,
  isLoading = false,
  isError = false,
}) => {
  const showAppropriateTextBasedOnState = () => {
    let text = "Add columns to preview data table.";

    if (isLoading) {
      text = "Loading data table. Please wait...";
    }

    if (isError) {
      text = "Error data table. Please try again later.";
    }

    return text;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          alignItems: "center",
          justifyContent: "center",
          width: "200px",
          padding: "200px 0px",
        }}
      >
        <IconButton
          edge="start"
          color="inherit"
          onClick={onAddColumn}
          disabled={isLoading}
          aria-label="add-column"
          size="medium"
        >
          <AddTableColumnIcon />
        </IconButton>

        <div>
          <Typography
            style={{
              fontFamily: " Avenir",
              textAlign: "center",
              fontSize: "16px",
              fontWeight: 400,
              color: "#000000",
              lineHeight: 1.5,
            }}
          >
            {showAppropriateTextBasedOnState()}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default EmptyStateCreateDataTable;
